/** Proyectos Ecasa (projects.id): el tope de Bono Pie usa unit.max_discount */
export const ECASA_PROJECT_IDS: readonly number[] = [
    2555, 2884, 3031, 3219, 3220, 3253, 3260, 3378, 3398, 3402,
    3407, 3409, 3410, 3473, 7696, 7704, 21428, 22356, 22357,
];

/** Proyectos con entrada decimal en bono pie / descuento del cotizador (projects.id) */
const ESTIMATOR_DECIMAL_PROJECT_IDS = new Set<number>([
    2553, 2554, 2555, 2558, 2884, 2975, 3031, 3219, 3220, 3253,
    3260, 3338, 3378, 3398, 3402, 3407, 3408, 3409,
]);

export const isEcasaProject = (projectId: number): boolean =>
    ECASA_PROJECT_IDS.includes(projectId);

export const isEstimatorDecimalProject = (projectId: number): boolean =>
    ESTIMATOR_DECIMAL_PROJECT_IDS.has(projectId);

export const parseMaxDiscount = (maxDiscount?: string): string =>
    maxDiscount?.replace('%', '').replace(',', '.').trim() || '0';
